const selectors = {
  toggleModal: '[data-toggle-modal]',
  modalClose: '[data-close-modal]',
};

/**
 * Initializes all modals on the page that have the data-modal attribute
 * @param {HTMLElement} [container=document] - Optional container to limit modal initialization scope
 * @returns {Function} Function to cleanup observer and modals
 *
 * Emits:
 *   'modal:opened' (CustomEvent) on the modal element when opened. Event detail contains { id: modalId }
 *   'modal:closed' (CustomEvent) on the modal element when closed. Event detail contains { id: modalId }
 *
 * Behavior:
 *   - Clicking the modal backdrop (outside modal content) will close the modal.
 */
export default function initModals() {
  const toggles = document.querySelectorAll(selectors.toggleModal);

  if (!toggles.length) {
    return;
  }

  toggles.forEach(toggle => {
    toggle.addEventListener('click', e => {
      e.preventDefault();
      const modalId = toggle.getAttribute('data-toggle-modal');
      const modal = document.getElementById(modalId);
      modal.showModal();

      // Emit custom event when modal is opened
      modal.dispatchEvent(new CustomEvent('modal:opened'));

      // Helper to close modal and emit event, and cleanup listeners
      const closeModal = () => {
        modal.close();
        modal.dispatchEvent(new CustomEvent('modal:closed'));
        modal.removeEventListener('click', backdropHandler);
        const modalClose = modal.querySelector(selectors.modalClose);
        modalClose.removeEventListener('click', closeModal);
      };

      // Backdrop handler needs to be referenced for removal
      const backdropHandler = backdropEvent => {
        if (backdropEvent.target === modal) {
          closeModal();
        }
      };

      // Attach listeners
      modal.addEventListener('click', backdropHandler);
      const modalClose = modal.querySelector(selectors.modalClose);
      modalClose.addEventListener('click', closeModal);
    });
  });
}
